<script lang="ts">
  import viewport from './useViewPortAction';

  const TYPE_TIMEOUT = 10;

  interface Props {
    heading: string
    caption: string
    style?: string
    animated?: boolean
    animationFinished?: () => void
  }

  let {
    heading,
    caption,
    style,
    animated,
    animationFinished,
  }: Props = $props();

  let shownHeading = $state<string>('');
  let shownCaption = $state<string>('');

  let headingIndex = 0;
  let captionIndex = 0;

  let animationStarted = false;

  const typeHeading = () => {
    shownHeading = shownHeading + heading[headingIndex];
    headingIndex = headingIndex + 1;

    if (headingIndex < heading.length) {
      setTimeout(typeHeading, TYPE_TIMEOUT);
    }
    else {
      typeCaption();
    }
  };

  const typeCaption = () => {
    shownCaption = shownCaption + caption[captionIndex];
    captionIndex = captionIndex + 1;

    if (captionIndex < caption.length) {
      setTimeout(typeCaption, TYPE_TIMEOUT);
    }
    else {
      animationFinished?.();
    }
  };

  const startAnimation = () => {
    if (!animated || animationStarted) {
      return;
    }

    animationStarted = true;
    typeHeading();
  };
</script>

<div
    style={style}
    use:viewport
    onEnterViewport={startAnimation}
>
    <div class="ft5-upselling-relative">
        <div class={{ 'oc-headline-50': true, 'ft5-upselling-heading': true, 'ft5-upselling-hidden': animated }}>
            {heading}
        </div>
        {#if animated}
            <div class="oc-headline-50 ft5-upselling-heading ft5-upselling-animation">{shownHeading}</div>
        {/if}
    </div>
    <div class="ft5-upselling-relative ft5-upselling-margin8">
        <div class={{ 'ft5-upselling-hidden': animated, 'oc-copy-75': true }}>{caption}</div>
        {#if animated}
            <div class="ft5-upselling-animation oc-copy-75">{shownCaption}</div>
        {/if}
    </div>
</div>

<style lang="scss">
  .ft5-upselling-relative {
    position: relative;
  }

  .ft5-upselling-heading {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
  }

  .ft5-upselling-hidden {
    visibility: hidden;
  }

  .ft5-upselling-animation {
    position: absolute;
    top: 0;
  }

  .ft5-upselling-margin8 {
    margin-top: 8px;
  }
</style>
